import { createSlice } from '@reduxjs/toolkit';

type InitialState = {
  selected: {
    outgoinginvoice_id: string;
    servicetype_enumid: string;
    invoicenr: string;
    invoicetype_enumid: string;
    invoicetype: string;
    name: string;
    invoicedate: string;
    outgoinginvoicetype_enumid: string;
    outgoinginvoicetype: string;
    totalinvoiceamount_mcid: string;
    totalinvoiceamount_mc: string;
    guid: string;
    totalinvoiceamount: string;
    duedate: string;
    paymentdate: string;
    outstandingamount_mcid: string;
    outstandingamount_mc: string;
    outstandingamount: string;
    undisputedamount_mcid: string;
    undisputedamount_mc: string;
    undisputedamount: string;
    disputedamount: string;
    invoicestate_enumid: string;
    invoicestate: string;
    licenseplate: string;
    paymentstatus:any
  } | null;
}
const initialState: InitialState = {
  selected: null,
};

const invoicesSlice = createSlice({
  name: 'invoices',
  initialState,
  reducers: {
    selectInvoice: (state, action) => {
      state.selected = action.payload;
    },
    resetSelectedInvoice: (state) => {
      state.selected = null;
    }
  },
  extraReducers: (builder) => {},
});

export default invoicesSlice.reducer;
export const { selectInvoice, resetSelectedInvoice } = invoicesSlice.actions;
